import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyChUKL_PoPqC_BjrD7HxsDryDjWjgcz5K4",
  authDomain: "talha-portfolio-5f735.firebaseapp.com",
  projectId: "talha-portfolio-5f735",
  storageBucket: "talha-portfolio-5f735.firebasestorage.app",
  messagingSenderId: "189268058284",
  appId: "1:189268058284:web:3891930592aa16d568bf09",
  measurementId: "G-BFK0GTF5MG"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

export { db, auth };
